import React, {useState} from 'react';
import {Button, Card, Form, Input, Modal, Table, Checkbox, message} from 'antd';
import {SaveOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
import {useNewRoleMutation, useGetRolesQuery} from "../../../../slices/rootApiSlices/roleApiSlice";

const RoleAddModal = ({visible, onClose}) => {

    const [form] = Form.useForm();
    const {user} = useSelector(state => state.auth);
    const [newRoleHandle, {isLoading, error}] = useNewRoleMutation();
    const {refetch} = useGetRolesQuery(user?.token);
    const [roleName, setRoleName] = useState("");

    const [permissionData, setPermissionData] = useState({
        roles: {
            read: true,
            write: true,
            delete: true,
            update: true,
        },
        users: {
            read: true,
            write: true,
            delete: true,
            update: true,
        },
        drivers: {
            read: true,
            write: true,
            delete: true,
            update: true,
        },
        vehicles: {
            read: true,
            write: true,
            delete: true,
            update: true,
        },
        lines: {
            read: true,
            write: true,
            delete: true,
            update: true,
        },
        reports: {
            read: true,
            write: true,
            delete: true,
            update: true,
        },
        live: {
            read: true,
            write: true,
            delete: true,
            update: true,
        },
    });

    const columns = [
        {
            title: 'Rol Adı',
            dataIndex: 'name',
            key: 'name',
            render: (text) => {
                switch (text) {
                    case 'Roles':
                        return 'Roller';
                    case 'Users':
                        return 'Kullanıcılar';
                    case 'Drivers':
                        return 'Sürücüler';
                    case 'Vehicles':
                        return 'Araçlar';
                    case 'Lines':
                        return 'Güzergahlar';
                    case 'reports':
                        return 'Raporlar';
                    case 'Live':
                        return 'Canlı İzleme';
                    default:
                        return text;
                }
            }
        },
        {
            title: 'Görüntüleme',
            dataIndex: 'read',
            key: 'read',
            render: (_, record) => <Checkbox checked={record.read}/>,
        },
        {
            title: 'Silme',
            dataIndex: 'delete',
            key: 'delete',
            render: (_, record) => <Checkbox checked={record.delete}/>,
        },
        {
            title: 'Ekleme',
            dataIndex: 'write',
            key: 'write',
            render: (_, record) => <Checkbox checked={record.write}/>
        },
        {
            title: 'Güncelleme',
            dataIndex: 'update',
            key: 'update',
            render: (_, record) => <Checkbox checked={record.update}/>
        },
    ];

    const dataSource = Object.keys(permissionData).map((key) => ({
        key: key,
        name: key.charAt(0).toUpperCase() + key.slice(1),
        read: permissionData[key]?.read || false,
        delete: permissionData[key]?.delete || false,
        write: permissionData[key]?.write || false,
        update: permissionData[key]?.update || false,
    }));

    const handleCheckboxChange = (category, actionType) => {
        setPermissionData((prevData) => ({
            ...prevData,
            [category]: {
                ...prevData[category],
                [actionType]: !prevData[category][actionType],
            },
        }));
    };

    const onFinish = async () => {
        const roleData = {
            name: roleName,
            action: permissionData
        }
        try {
            const res = await newRoleHandle({token: user?.token, data: roleData}).unwrap();
            if (res?.status) {
                onClose();
                refetch();
                form.setFieldsValue({
                    roleName: "",
                });
                message.success('Rol oluşturma işlemi başarılı', 3)
            }
        } catch (e) {
            message.error(e?.data?.messageTR)
            onClose();
        }
    };


    return (
        <Modal
            width={900}
            title="Yeni Rol Oluştur"
            open={visible}
            onCancel={onClose}
            footer={[
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    onClick={onFinish}
                    disabled={!roleName}
                    icon={<SaveOutlined/>}
                >
                    Kaydet
                </Button>,
            ]}
        >
            <Card type="inner" size="small" bordered={true}>
                <Form
                    name="add-role"
                    onFinish={onFinish}
                    onFinishFailed={error?.data?.messageTR}
                    autoComplete="off"
                    form={form}
                >
                    <Form.Item label="Rol Adı" style={{marginBottom: 10}}>
                        <Form.Item
                            style={{display: 'inline-block', width: '94%', marginLeft: '45px', margin: '0 8px'}}
                            name="roleName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Lütfen role adı giriniz !',
                                },
                            ]}
                            onChange={(e) => setRoleName(e.target.value)}
                            value={roleName}
                        >
                            <Input disabled={isLoading} placeholder="Role Adı"/>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item label="Rolün Yetkileri">
                        <Table
                            rowKey="key"
                            bordered={true}
                            dataSource={dataSource}
                            size="small"
                            loading={isLoading}
                            pagination={false}
                            columns={[
                                ...columns.slice(0, 1),
                                ...columns.slice(1).map((col) => ({
                                    ...col,
                                    render: (_, record) => (
                                        <Checkbox checked={record[col.dataIndex]}
                                                  onChange={() => handleCheckboxChange(record.key, col.dataIndex)}/>
                                    ),
                                })),
                            ]}
                        />
                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    );
};

export default RoleAddModal;
